import { DOCUMENT, effect, inject, Injectable } from '@angular/core';
import { Colors, CorporateDesign, Fonts, Icons } from '../models/organisation.model';
import { LandingpageConfigurationStateService } from './state/landingpage-configuration-state.service';

@Injectable({
  providedIn: 'root',
})
export class CorporateDesignService {
  private document = inject<Document>(DOCUMENT);
  private landingpageConfigurationStateService = inject(LandingpageConfigurationStateService);

  private root: HTMLElement;

  constructor() {
    this.root = this.document.querySelector(':root')!;

    effect(() => {
      const organisation = this.landingpageConfigurationStateService.organisation();

      if (organisation) {
        this.updateTheme(organisation.corporateDesign);
      }
    });
  }

  getColor(name: string) {
    return this.root.style.getPropertyValue(name);
  }

  setMaterialSymbolsLoaded(loaded: boolean) {
    this.root.style.setProperty('--icon-visibility', loaded ? 'visible' : 'hidden');
  }

  private updateTheme(corporateDesign: CorporateDesign) {
    this.updateColors(corporateDesign.colors);
    this.updateFonts(corporateDesign.fonts);

    const assetBucketUrl = this.landingpageConfigurationStateService.assetStackBucketUrl();
    if (assetBucketUrl) {
      this.updateIcons(corporateDesign.icons, assetBucketUrl);
    }
  }

  private updateColors(colors: Colors) {
    this.root.style.setProperty('--primary-text-color', colors.primaryTextColor);
    this.root.style.setProperty('--secondary-text-color', colors.secondaryTextColor);
    this.root.style.setProperty('--tertiary-text-color', colors.tertiaryTextColor);
    this.root.style.setProperty('--primary-background-color', colors.primaryBackgroundColor);
    this.root.style.setProperty('--secondary-background-color', colors.secondaryBackgroundColor);
    this.root.style.setProperty('--tertiary-background-color', colors.tertiaryBackgroundColor);
    this.root.style.setProperty('--active-ui-color', colors.activeUiColor);
    this.root.style.setProperty('--active-ui-text-color', colors.activeUiTextColor);
    this.root.style.setProperty('--inactive-ui-color', colors.inactiveUiColor);
    this.root.style.setProperty('--inactive-ui-text-color', colors.inactiveUiTextColor);
    this.root.style.setProperty('--error-color', colors.errorColor);
  }

  private updateIcons(icons: Icons, assetBucketUrl: string): void {
    const faviconSvg = this.document.querySelector('#favicon-svg') as HTMLLinkElement;
    const faviconIco = this.document.querySelector('#favicon-ico') as HTMLLinkElement;

    if (icons.faviconSvg) faviconSvg.setAttribute('href', assetBucketUrl + icons.faviconSvg);
    if (icons.faviconIco) faviconIco.setAttribute('href', assetBucketUrl + icons.faviconIco);
  }

  private updateFonts(fonts: Fonts): void {
    this.root.style.setProperty('--font-family', fonts.primaryFont);
  }
}
